import { Markdown } from 'components/Markdown'

export interface PostTextProps {
  text: string
}

export default function PostText({ text }: PostTextProps) {
  return (
    <Markdown className="max-w-[100%] text-justify leading-7 [&_div]:mb-10">
      {text}
    </Markdown>
  )
}
